import React, {useContext} from "react";
import {createUseStyles} from "react-jss";
import {EngageAppContext} from "../../App";
import {TriviaRunning, TriviaStatus} from "../../state/state";
import Button from "engage-client/components/Button";
import {TriviaAction} from "../../messages/messages";

const useStyles = createUseStyles({
    actionButton: {
        margin: [0,8],
        minWidth: 102
    }
});

export default function HostActions() {
    const {sendMessage, appState} = useContext(EngageAppContext.current);
    const classes = useStyles();

    function reset() {
        if(window.confirm("Are you sure you want to reset the game? You will lose all response data." +
            " Screenshot the leaderboard or Download Results from the options tab to save results for later.")) {
            sendMessage({type: TriviaAction.Reset});
        }
    }

    return (
        <>
            <Button className={classes.actionButton} color="primary"
                    onClick={() => {sendMessage({type: TriviaAction.Begin});}}
                    disabled={appState.common.state !== TriviaStatus.Pending}>Begin!</Button>
            <Button className={classes.actionButton} color="primary"
                    onClick={() => {sendMessage({type: TriviaAction.Pause});}}
                    disabled={!TriviaRunning.includes(appState.common.state)}>
                {appState.common.pauseMark ? "Unpause!" : "Pause!"}
            </Button>
            <Button className={classes.actionButton} color="primary"
                    onClick={() => {sendMessage({type: TriviaAction.Advance});}}
                    disabled={!TriviaRunning.includes(appState.common.state)}>Advance!</Button>
            <Button className={classes.actionButton} color="primary"
                    onClick={reset}
                    disabled={appState.common.state === TriviaStatus.Pending}>Reset!</Button>
        </>
    );
};